<div class="multi-login-container">
  <!-- <div class="left">
    <div class="square-select first">
      <div class="center-content">
        <h1 class="title">¿Estas de paso por aquí?</h1>
        <p class="information">Sin una cuenta propia de Akana, generarás tu informe
          de nuevo cada vez que entres y no podrás consultarlo
          cuando quieras.</p>
        <div class="btn-container">
          <button id="guestButton" (click)="goToUrl('terms')">Entrar como Invitado</button>
        </div>
      </div>
    </div>
  </div> -->
  <div class="right">
    <div class="square-select">
      <div class="center-content">
        <h1 class="title">
          ¡Hola! 👋🏼 Te estábamos esperando
        </h1>
        <p class="information">Entra en Akana y descubre cómo marchan tus finanzas.</p>
        <form autocomplete="off" method="POST" class="form-sign" [formGroup]="signForm">
          <div class="input-control-error">
            <input type="text" id="userId" [ngClass]="{'error-input': signForm.controls.email.value && signForm.controls.email.invalid &&
              signForm.controls.email.touched || !signForm.controls.email.value && signForm.controls.email.touched}"
              formControlName="email" class="input-search" name="" placeholder="Email">
            <div class="div-error"
              *ngIf="signForm.controls.email.value && signForm.controls.email.invalid && signForm.controls.email.touched">
              {{ 'SIGN.ERRORS.EMAIL_VALID' | translate }}
            </div>
            <div class="div-error" *ngIf="!signForm.controls.email.value && signForm.controls.email.touched"
              [innerHTML]=" 'SIGN.ERRORS.EMAIL_REQUIRED' | translate">
            </div>
          </div>
          <div class="input-control-error">
            <div class="see-pass">
              <input type="{{type}}" id="passwordId"
                [ngClass]="{'error-input': !signForm.controls.password.value && signForm.controls.password.touched }"
                formControlName="password" class="input-search" name="" placeholder="Contraseña" required>
              <img src="./assets/signin/see_pass.svg" *ngIf="signForm.controls.password.value" (mousedown)="showPass(1)"
                (mouseup)="showPass(2)" alt="">
            </div>
            <div class="div-error" *ngIf="!signForm.controls.password.value && signForm.controls.password.touched"
              [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
            </div>
          </div>
          <h2 id="forget" (click)="goToUrl('multi-signin/forget-pass')"
            [ngStyle]="{'margin': receptionMessage ? '0 0 12px 0' : '0 0 37px 0'}">¿Has
            olvidado tu contraseña?</h2>
          <p class="errors" *ngIf="receptionMessage">{{receptionMessage}}</p>
          <div class="btn-container">
            <button class="sign-in first" id="signInId" (click)="login(1)" [ngClass]="{'ready': signForm.valid }"
              *ngIf="!showProgress">Iniciar Sesión</button>
            <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="showProgress"
              mode="indeterminate">
            </mat-progress-bar>
          </div>
          <h3 style="width: 100%; text-align: center;" (click)="goToUrl('signin')">No tengo una cuenta. Crear cuenta</h3>
          <p class="init-session">O</p>
          <div class="group-session">
            <button class="consumer" (click)="goToUrl('signinSCF')" id="signInConsumer">
              <img src="./assets/signin/flame_santander.png" alt="">&nbsp;&nbsp;&nbsp; Continuar con Santander Consumer
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
